<template>
  <VDialogV3
    id="budget-prices-history-dialog"
    position="right"
    width="900px"
    :title="'История бюджетной цены: ' + product.name"
    :loading="isLoading"
    hide-footer
    hide-feed
  >
    <VDataGridV2
      class="fill"
      :data="budgetPrices"
    >
      <VDataGridColumnV2
        id="validityPeriodStart"
        label="Действует с"
        width="110px"
        content-align="center"
      >
        <template #default="{ row }">
          {{ row.validityPeriod.start?.format() ?? '--' }}
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        id="validityPeriodEnd"
        label="по"
        width="110px"
        content-align="center"
      >
        <template #default="{ row }">
          {{ row.validityPeriod.end?.format() ?? '--' }}
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        id="price"
        label="Цена"
        width="180px"
        content-align="right"
        header-class="nowrap"
      >
        <template #default="{ row }">
          {{ row.price.format(row.currency, row.product.unit) }}
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        id="optimalPurchaseQty"
        label="Оптимальный объём закупки СЗ"
        width="200px"
        content-align="right"
        header-class="nowrap"
      >
        <template #default="{ row }">
          {{ row.optimalPurchaseQty?.formatSmart(row.product.unit) ?? '--' }}
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        id="createdBy"
        label="Завёл"
        content-class="ellipsis"
      >
        <template #default="{ row }">
          {{ row.createdBy?.name ?? '--' }}
          <template v-if="Core.utils.isNullOrUndefined(row.createdAt) === false">
            {{ row.createdAt.format() }}
          </template>
        </template>
      </VDataGridColumnV2>
    </VDataGridV2>
  </VDialogV3>
</template>

<script lang="ts">
import Core                from "@/core/Core";
import BudgetPrice         from "@/domains/BudgetPrices/BudgetPrice";
import BudgetPricesService from "@/domains/BudgetPrices/BudgetPricesService";
import type Product        from "@/domains/Products/Product";

export default defineComponent({
  name: "BudgetPricesHistoryDialog",

  props: {
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
  },

  setup() {
    return {
      Core,
    }
  },

  data() {
    return {
      budgetPrices: [] as BudgetPrice[],
      isLoading: true,
    }
  },

  async mounted() {
    this.budgetPrices = await BudgetPricesService.getHistory(this.product.id);
    this.isLoading = false;
  },
})
</script>
